import { routeName } from 'app/routes/route-constants';
import { CaseConnectionParam } from 'app/infrastructure/ui/form/types';
import { QueryObject } from 'app/components/enhancers/with-router';
import { LocationDescriptorObject } from 'app/types-shared';
import { isCaseViewModalOpen } from 'app/components/helpers';

/**
 * Serialize router query parameters to a object array, in reverse/chronological order
 *
 * @param query 
 */
// eslint:disable-next-line:one-variable-per-declaration
export const deserializeConnectionState = (query: QueryObject): CaseConnectionParam[] =>{ 
  return (

  Array.isArray(query.draftId) ?

    query.draftId.map((val, i) => ({
      caseId: Number(query.caseId[i]),
      draftId: Number(val),
      connectionTypeId: Number(query.connectionTypeId[i]),
      sequence: Number(query.sequence[i]),
      etag: decodeURIComponent(query.etag[i])
    }))
    :
    query.draftId ?
      [{
        caseId: Number(query.caseId),
        draftId: Number(query.draftId),
        connectionTypeId: Number(query.connectionTypeId),
        sequence: Number(query.sequence),
        etag: decodeURIComponent(query.etag)
      }]
      :
      undefined
)};

/**
 * Serialize as query string
 * 
 * @param queue 
 */
export const serializeConnectionState = (queue: CaseConnectionParam[]) => {
  if(!queue || !queue.length){
    return '';
  }

const qs = queue.reverse().map( 
  item => `${
`${`caseId=${item.caseId || 0}`}&draftId=${item.draftId || 0}`}&connectionTypeId=${item.connectionTypeId}&sequence=${item.sequence}&etag=${encodeURIComponent(item.etag)}`
).join('&');

  return qs ? `?${qs}` : '';};


/**
 * Create a routable link to the previous item in the case connection chain, preserving it's queue state
 * 
 * @param queue 
 */
export const getLocationOfInitiator = (queue: CaseConnectionParam[]): LocationDescriptorObject => {
  if(!queue || !queue.length){
    return undefined;
  }

  const { [queue.length -1] : lastItem } = queue;
  if(!lastItem || !(lastItem.draftId || lastItem.caseId)){
    throw new Error('Invalid id for draft location');
  }  
  const currentPath = window.location.pathname;
  const useReverseConnection = !!lastItem.caseId;
  const basePath = isCaseViewModalOpen() ? currentPath.split('/case')[0].split('/').filter(f=>f).join('/') : '';
  const draftRoute = isCaseViewModalOpen() ? `${routeName.Case}/${routeName.Draft}` : routeName.Draft;
  const pathnames = useReverseConnection ? `${basePath ? `${basePath}/` : ''}${routeName.Case}` : 
    `${basePath ? `${basePath}/` : ''}${draftRoute}`;
  const ids = useReverseConnection ? lastItem.caseId : lastItem.draftId;
  return ({ 
    pathname: `/${pathnames}/${ids}`,
    state: {internal: false} ,
    search: serializeConnectionState(queue.slice(0, -1))
  });
};
